// Bloque promocional "Tarjetas regalo para empresas": enlaza a /empresas.
// Se usa en la portada y en /regalo. Textos principales de lib/empresasTxt.
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Building2, ArrowRight } from 'lucide-react';
import { tt } from '../lib/empresasTxt';

const CTA = {
  es: 'Pedir tarjetas para mi empresa',
  en: 'Order cards for my company',
  fr: 'Commander des cartes pour mon entreprise',
  ru: 'Заказать карты для моей компании',
};

export default function EmpresasCTA({ compacto = false }) {
  const { i18n } = useTranslation();
  const lang = (i18n.resolvedLanguage || 'es').toLowerCase();
  return (
    <section className={'empresas-cta' + (compacto ? ' empresas-cta--compacto' : '')}>
      <div className="empresas-cta-icono"><Building2 size={26} strokeWidth={1.5} /></div>
      <div className="empresas-cta-texto">
        <span className="empresas-cta-eyebrow">{tt(lang, 'eyebrow')}</span>
        <h2>{tt(lang, 'titulo')}</h2>
        <p>{tt(lang, 'sub')}</p>
      </div>
      <Link to="/empresas" className="empresas-cta-btn">
        {CTA[lang] || CTA.es} <ArrowRight size={16} />
      </Link>
    </section>
  );
}
